import axios from "axios";
import { toast } from "react-toastify";
import { CODE, StorageConstants, VALIDATION_MESSAGE } from "../constants/Constants";
import { getFromStorage, handleLogout, isAuthenticated } from "../utils/Helper";
import { Config } from "../config/Config";


const apiinstance = axios.create({
    baseURL: Config?.REACT_APP_API_BASE_URL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
        ...(isAuthenticated() && { "Authorization": "Bearer " + isAuthenticated() }),
        "platform": getFromStorage({ key: StorageConstants?.PLATFORM }),
        "x-device-token": getFromStorage({ key: StorageConstants?.FCM_TOKEN }),
        "ngrok-skip-browser-warning": "69420"
    }
})


apiinstance.interceptors.request.use(
    config => {
        const token = getFromStorage({ key: StorageConstants?.ACCESS_TOKEN });
        console.log("token - ", token)
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

const apiinstanceFormData = axios.create({
    baseURL: Config?.REACT_APP_API_BASE_URL,
    headers: {
        Accept: "application/json",
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "",
        "Access-Control-Allow-Headers": "",
        "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
        ...(isAuthenticated() && { "Authorization": "Bearer " + isAuthenticated() }),
        "platform": getFromStorage({ key: StorageConstants?.PLATFORM }),
        "x-device-token": getFromStorage({ key: StorageConstants?.FCM_TOKEN }),

    }
})


apiinstanceFormData.interceptors.request.use(
    config => {
        const token = getFromStorage({ key: StorageConstants?.ACCESS_TOKEN });
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export const POSTAPI = (URL: string, params: any, toastStatus: any = true) => {
    const promise = apiinstance.post(URL, params, {
        validateStatus: status => status >= 200 && status < 600
    });
    const dataPromise = promise.then((response) => response).then((response) => {
        if (response?.status === CODE?.OK_CODE || response?.status === CODE?.CREATED) {

            if (toastStatus) {
                toast.success(response.data?.message, {
                    autoClose: 10000, // 20 seconds
                });
            }
            if (response?.data?.status) {
                // toast.success(response.data?.message);
                return response.data;
            }
            else if (response?.data?.status_code === CODE?.NO_CONTENT) {
                return response?.data;

            }
            else {
                if (toastStatus) {
                    toast.error(response.data?.message, {
                        autoClose: 20000, // 20 seconds
                    });
                }
                return response.data;
            }
        }
        else if (response?.status === CODE?.BAD_REQUEST_CODE) {
            if (toastStatus) {
                toast.error(response.data?.message, {
                    autoClose: 20000, // 20 seconds
                });
            }
            return response?.data;
        }
        else if (response?.status === CODE?.UNAUTHORIZED_CODE) {
            handleLogout()
        }
        else if (response?.status === CODE?.INTERNAL_SERVER_ERROR) {
            if (toastStatus) {
                toast.error(response.data?.message, {
                    autoClose: 20000, // 20 seconds
                });
            }
            return response?.data;

        }
        else if (response?.status === CODE?.VALIDATION_CODE) {
            if (toastStatus) {
                toast.error(response.data?.message, {
                    autoClose: 20000, // 20 seconds
                });
            }
            return response?.data;

        }
        else {
            if (toastStatus) {
                toast.error(VALIDATION_MESSAGE?.CATCH_ERROR);
            }
        }
    }).catch((error) => {
        // return error;   
        if (error?.response?.status === CODE?.UNAUTHORIZED_CODE) {
            handleLogout()
        }
        if (toastStatus) {
            toast.error(VALIDATION_MESSAGE?.CATCH_ERROR);
        }
    });
    return dataPromise;
};

export const POSTAPIFORMDATA = (URL: string, params: any, toastStatus: any = true) => {
    const promise = apiinstanceFormData.post(URL, params, {
        validateStatus: status => status >= 200 && status < 600
    });
    const dataPromise = promise.then((response) => response).then((response) => {

        if (response?.status === CODE?.OK_CODE || response?.status === CODE?.CREATED) {
            if (toastStatus) {
                toast.success(response.data?.message, {
                    autoClose: 10000, // 20 seconds
                });
            }
            if (response?.data?.status) {
                // toast.success(response.data?.message);
                return response.data;
            }
            else if (response?.data?.status_code === CODE?.NO_CONTENT) {
                return response?.data;

            }
            else {
                if (toastStatus) {
                    toast.error(response.data?.message, {
                        autoClose: 20000, // 20 seconds
                    });
                }
                return response.data;
            }
        }
        else if (response?.status === CODE?.BAD_REQUEST_CODE) {
            if (toastStatus) {
                toast.error(response.data?.message, {
                    autoClose: 20000, // 20 seconds
                });
            }
            return response?.data;
        }
        else if (response?.status === CODE?.UNAUTHORIZED_CODE) {
            handleLogout()
        }
        else if (response?.status === CODE?.INTERNAL_SERVER_ERROR) {
            if (toastStatus) {
                toast.error(response.data?.message, {
                    autoClose: 20000, // 20 seconds
                });
            }
            return response?.data;

        }
        else if (response?.status === CODE?.VALIDATION_CODE) {
            if (toastStatus) {
                toast.error(response.data?.message, {
                    autoClose: 20000, // 20 seconds
                });
            }
            return response?.data;

        }
        else {
            if (toastStatus) {
                toast.error(VALIDATION_MESSAGE?.CATCH_ERROR);
            }
        }
    }).catch((error) => {

        if (error?.response?.status === CODE?.UNAUTHORIZED_CODE) {
            handleLogout()
        }
        if (toastStatus) {
            toast.error(VALIDATION_MESSAGE?.CATCH_ERROR);
        }
    });
    return dataPromise;
};


export const GETAPI = (URL: string, params: any = {}, toastStatus: any = false) => {
    const promise = apiinstance.get(URL, params)

    const dataPromise = promise.then((response) => response).then((response) => {

        if (response?.status === 200 || response?.status === 201) {
            //  toast.success(response.data?.message)
            if (toastStatus) { toast.success(response.data?.message) }
            return response.data;
        } else {
            if (toastStatus) {
                toast.error(response.data?.message)
            }
            return response?.data;
        }
    }).catch((error) => {
        if (error?.response?.status === CODE?.UNAUTHORIZED_CODE) {
            handleLogout()
        }
    })
    return dataPromise;
}

